import { Injectable } from '@angular/core';
import {
  EdytujUstawieniaSystemuRequest,
  UstawieniaSystemuDto,
} from '@interfaces/administracja/systems/informacje-o-systemie.interface';
import { VersionInfo } from '@interfaces/administracja/systems/version-info.interface';
import { WersjaDto } from '@interfaces/administracja/systems/wersja.interface';
import { ApiBaseService } from '@services/api-base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class InformacjeOSystemieService extends ApiBaseService {
  private readonly endpoint = `${this.apiUrl}/systems`;
  private versionInfoUrl = 'assets/version-info.json';

  getWersja(): Observable<WersjaDto> {
    return this.http.get<WersjaDto>(`${this.endpoint}/wersja`);
  }

  getGUIVersionFromJSONFile(): Observable<VersionInfo> {
    return this.http.get<VersionInfo>(this.versionInfoUrl);
  }

  getAPIVersion(): Observable<VersionInfo> {
    return this.http.get<VersionInfo>(this.versionInfoUrl);
  }

  getSystemSettings(): Observable<UstawieniaSystemuDto> {
    return this.http.get<UstawieniaSystemuDto>(`${this.endpoint}/ustawienia-systemu`);
  }

  saveSystemLogo(data: FormData): Observable<null> {
    return this.http.put<null>(`${this.endpoint}/ustawienia-systemu/logo`, data);
  }

  saveUstawieniaSystemu(data: EdytujUstawieniaSystemuRequest): Observable<null> {
    return this.http.put<null>(`${this.endpoint}/ustawienia-systemu`, data);
  }
}
